import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "id"];
import styled from "@emotion/styled";
import { genId, useForkRef } from "@smartsheet/lodestar-utils";
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React, { forwardRef, useEffect, useMemo, useRef } from "react";
import { createFocusRingStyles } from "../../util/createFocusRingStyles";
import { withFocusToggleClassName } from "../../util/withFocusClassName";
import { useTabsContext } from "./TabsContext";
import { tabsTheme } from "./tabsTheme";
var StyledTabPanel = withFocusToggleClassName(styled("div")(function (_ref) {
  var themeMode = _ref.themeMode;
  return createFocusRingStyles({
    theme: themeMode,
    componentRadius: tabsTheme.focusRingRadius(themeMode),
    gap: tabsTheme.focusRingGap(themeMode),
    componentBorderWidth: 0
  });
}));
StyledTabPanel.displayName = "StyledTabPanel";
export var TabPanel = /*#__PURE__*/forwardRef(function (_ref2, parentRef) {
  var children = _ref2.children,
    id = _ref2.id,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var theme = useCombinedThemeMode();
  var _useTabsContext = useTabsContext(),
    onlyRenderActiveTabPanelChildren = _useTabsContext.onlyRenderActiveTabPanelChildren,
    registerTabPanel = _useTabsContext.registerTabPanel,
    selectedId = _useTabsContext.selectedId,
    tabRegistrations = _useTabsContext.tabRegistrations;
  var localRef = useRef(null);
  var ref = useForkRef(localRef, parentRef);
  var finalId = useMemo(function () {
    return id !== null && id !== void 0 ? id : genId("smar--tab--panel");
  }, [id]);
  var thisReg = tabRegistrations.find(function (_ref3) {
    var panelRef = _ref3.panelRef;
    return (panelRef === null || panelRef === void 0 ? void 0 : panelRef.current) === localRef.current;
  });
  var isSelected = (thisReg === null || thisReg === void 0 ? void 0 : thisReg.tabId) === selectedId;
  useEffect(function () {
    if (localRef.current) {
      var _registerTabPanel = registerTabPanel(finalId, localRef),
        unregister = _registerTabPanel.unregister;
      return unregister;
    }
  }, [finalId, registerTabPanel]);
  return /*#__PURE__*/React.createElement(StyledTabPanel, _extends({}, rest, {
    themeMode: theme,
    ref: ref,
    role: "tabpanel",
    tabIndex: isSelected ? 0 : -1,
    id: finalId,
    "aria-labelledby": thisReg === null || thisReg === void 0 ? void 0 : thisReg.tabId,
    style: {
      display: isSelected ? undefined : "none"
    },
    hidden: !isSelected
  }), onlyRenderActiveTabPanelChildren ? isSelected ? children : null : children);
});
TabPanel.displayName = "TabPanel";
//# sourceMappingURL=TabPanel.js.map